import { tv } from "@/utils/tv.config";
import type { VariantProps } from "tailwind-variants";

export const fieldSetClasses = tv({
  slots: {
    root: "flex w-full flex-col gap-4",
    legend: "border-b border-gray-200 pb-3 text-lg font-medium text-gray-900",
    columns: "grid grid-cols-1 gap-4",
  },
  variants: {
    columns: {
      1: {
        columns: "sm:grid-cols-1",
      },
      2: {
        columns: "sm:grid-cols-2",
      },
      3: {
        columns: "sm:grid-cols-3",
      },
      4: {
        columns: "sm:grid-cols-4",
      },
      5: {
        columns: "sm:grid-cols-5",
      },
      6: {
        columns: "sm:grid-cols-6",
      },
    },
  },
});

export const {
  root: fieldSetRootClasses,
  legend: fieldSetLegendClasses,
  columns: fieldSetColumnsClasses,
} = fieldSetClasses();

export type FieldSetVariants = VariantProps<typeof fieldSetRootClasses>;
